<template>
	<div class="about">
		<div class="page-container">
			<PageTitle ch="關於偶戲村" en="About Lìzé Puppet Art Colony"></PageTitle>
			<BannerSplit2About></BannerSplit2About>
			<PageTitle class="item-title" ch="業務項目" en="Programs &amp; Activities"></PageTitle>
			<div class="programs row no-gutters justify-content-center">
				<div class="col-lg-3 col-md-6 col-sm-12 program1 p-item">
					<img src="@/assets/about/item-1.png" alt="" srcset="">
					<div class="inside">
						<img class="icon" src="@/assets/about/icon_PA_1.svg" alt="">
						<h3 class="title-ch">國際大師班、藝術家駐村</h3>
						<h3 class="title-en">International masterclass,artist-in-residence programs</h3>
					</div>
				</div>
				<div class="col-lg-3 col-md-6 col-sm-12 program2 p-item">
					<img src="@/assets/about/item-2.png" alt="" srcset="">
					<div class="inside">
						<img class="icon" src="@/assets/about/icon_PA_2.svg" alt="">
						<h3 class="title-ch">偶戲教學工作坊、偶戲研習營隊（專業人士、教師）</h3>
						<h3 class="title-en">Practice of Puppetry education (for adults and teachers)</h3>
					</div>
				</div>
				<div class="col-lg-3 col-md-6 col-sm-12 program3 p-item">
					<img src="@/assets/about/item-3.png" alt="" srcset="">
					<div class="inside">
						<img class="icon" src="@/assets/about/icon_PA_3.svg" alt="">
						<h3 class="title-ch">參觀展示服務 (一般民眾)</h3>
						<h3 class="title-en">Art colony visits (open to public)</h3>
					</div>
				</div>
				<div class="col-lg-3 col-md-6 col-sm-12 program4 p-item">
					<img src="@/assets/about/item-4.png" alt="" srcset="">
					<div class="inside">
						<img class="icon" src="@/assets/about/icon_PA_4.svg" alt="">
						<h3 class="title-ch">專案展覽體驗活動 (企業邀約、表演規劃)</h3>
						<h3 class="title-en">Customized programs (for companies, organizations,or anyone who are interested)</h3>
					</div>
				</div>
				<div class="col-lg-3 col-md-6 col-sm-12 program5 p-item">
					<img src="@/assets/about/item-5.png" alt="" srcset="">
					<div class="inside">
						<img class="icon" src="@/assets/about/icon_PA_5.svg" alt="">
						<h3 class="title-ch">偶戲教育推廣 (學校、戶外教學、親子)</h3>
						<h3 class="title-en">Puppetry-popularizing projects (for schools, field trips, and family activities)</h3>
					</div>
				</div>
				<div class="col-lg-3 col-md-6 col-sm-12 program6 p-item">
					<img src="@/assets/about/item-6.png" alt="" srcset="">
					<div class="inside">
						<img class="icon" src="@/assets/about/icon_PA_6.svg" alt="">
						<h3 class="title-ch">偶戲村預約導覽 (團體30人以上)</h3>
						<h3 class="title-en">Guided tour with an introduction to puppetry (for groups over 30 people)</h3>
					</div>
				</div>
				<div class="col-lg-3 col-md-6 col-sm-12 program7 p-item">
					<img src="@/assets/about/item-7.png" alt="" srcset="">
					<div class="inside">
						<img class="icon" src="@/assets/about/icon_PA_7.svg" alt="">
						<h3 class="title-ch">文創空間租借 (藝享基地、排練場、製偶工廠)</h3>
						<h3 class="title-en">Space booking (art hub, rehearsal studio, and puppet factory)</h3>
					</div>
				</div>
				<div class="col-lg-3 col-md-6 col-sm-12 program8 p-item">
					<img src="@/assets/about/item-8.png" alt="" srcset="">
					<div class="inside">
						<img class="icon" src="@/assets/about/icon_PA_8.svg" alt="">
						<h3 class="title-ch">偶戲文創產品</h3>
						<h3 class="title-en">Puppetry-related cultural and creative products</h3>
					</div>
				</div>
			</div>
			<PageTitle ch="「利澤國際偶戲藝術村」大事紀" en=""></PageTitle>
			<transition mode="out-in">
				<Timeline></Timeline>
			</transition>
		</div>
	</div>
</template>


<script>
import PageTitle from '@/components/page_title'
import Timeline from '@/components/timeline'
import BannerSplit2About from '@/components/banner/banner_split2_about'

export default {

  metaInfo: {
    title: '利澤國際偶戲藝術村'
  },
  name: 'about',
  data() {
    return {

    }
  },
  components: {
    PageTitle,
    BannerSplit2About,
    Timeline
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
  @import '../../stylesheet/base.sass'
  @import '../../stylesheet/layout.sass'

  .about
    .item-title
      margin-top: 73px
    .programs
      width: 100%
      max-width: 1440px
      padding: 0 50px
      margin: 0 auto
      .p-item
        overflow: hidden
        margin-top: 20px
        position: relative
        img
          width: 100%
          min-width: 200px
          height: auto
          opacity: 0
          transform: 1s
        .inside
          +flexLayout('start2', 'col')
          border: 1px solid $themeColor
          height: 90%
          width: 90%
          position: absolute
          transform: translateX(-50%) translateY(-50%)
          top: 50%
          left: 50%
          color: black
          text-align: center
          padding: 0 10px
          .icon
            +size(28px, 28px)
            opacity: 1
            margin-top: 18%
          .title-en
            font-size: $font-size-4
            margin-top: 10px
            letter-spacing: 3px

          .title-ch
            font-size: $font-size-3
            letter-spacing: 3px
            margin-top: 28px
            line-height: 1.3
        &:hover
          img
            opacity: 1
          .inside
            color: white




</style>



// WEBPACK FOOTER //
// src/pages/about/about.vue